import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const SELECTORS = {
    parallax: '[data-parallax]',
    element: '[data-parallax-element]'
}

const PREFERS_REDUCED_MOTION_MQ = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
)

const PREFERS_REDUCED_MOTION = PREFERS_REDUCED_MOTION_MQ.matches

gsap.registerPlugin(ScrollTrigger)
ScrollTrigger.config({ ignoreMobileResize: true })

if (!PREFERS_REDUCED_MOTION) {
    const parallaxElements = document.querySelectorAll(SELECTORS.element)

    if (parallaxElements) {
        parallaxElements.forEach((element) => {
            gsap.to(element, {
                ease: 'none',
                yPercent: -30,
                scrollTrigger: {
                    trigger: element.closest(SELECTORS.parallax),
                    invalidateOnRefresh: true,
                    scrub: 1
                }
            })
        })
    }
}
